import { createUseStyles } from 'react-jss';
export default createUseStyles({
  container: {
    position: 'absolute',
    width: 518,
    height: '100%',
    zIndex: 1004,
    backgroundColor: 'white',
    opacity: 1
  },
  content: {
    position: 'relative',
    '& > a': {
      position: 'absolute',
      right: 20,
      top: 20,
      cursor: 'pointer',
      fill: 'black',
      height: 24
    }
  },
  mobile: {
    width: '100%',
    height: '100%'
  },
  left: {
    top: 0,
    left: 0,
    transformOrigin: 'left center'
  },
  right: {
    right: 0,
    top: 0,
    transformOrigin: 'right center'
  },
  top: {
    top: 0,
    left: 0,
    height: 518,
    width: '100%',
    transformOrigin: 'center top'
  },
  bottom: {
    bottom: 0,
    left: 0,
    height: 518,
    width: '100%',
    transformOrigin: 'center bottom'
  }
});